/**
 * @author tonicli
 * @date 2017/7/29
 */

const REG = /(\d+)(?:\.(\d+))?(?:\.(\d+))?(?:\.([\w-]+))?/;
export default class Version {
  /**
   *@param {string} version
   */
  constructor(version) {
    const [major, minor, patch, build] = Version.parse(version);
    this.major = major;
    this.minor = minor;
    this.patch = patch;
    this.build = build;
  }
  toString() {
    const r = this.toArray();
    const breakPos = r.indexOf(undefined);
    return r.slice(0, breakPos > -1 ? breakPos : r.length).join('.');
  }
  toArray() {
    return [this.major, this.minor, this.patch, this.build];
  }
  /**
   *@param {Version|string} version
   *@param {Boolean} [greatAndEqual]
   */
  compare(version, greatAndEqual = true) {
    const r1 =        version instanceof Version ? version.toArray() : Version.parse(version);

    const r2 = this.toArray();

    for (let i = 0; i < r1.length; i++) {
      const v2 = r2[i] || 0;

      const v1 = r1[i] || 0;
      if (v2 !== v1) {
        return v2 > v1;
      }
    }

    return greatAndEqual;
  }
  /**
   *@param {Version|string} version
   */
  equal(version) {
    const [major, minor, patch, build] =      version instanceof Version ? version.toArray() : Version.parse(version);

    return (
      this.major === major
      && this.minor === minor
      && this.patch === patch
      && this.build === build
    );
  }
  /**
   *@param {string} version
   */
  static parse(version) {
    const matches = version.match(REG);
    if (!matches) {
      throw new Error(`[Version.parse]invalid version format(${version})`);
    }
    return matches.slice(1).map((v) => {
      const n = parseInt(v, 10);
      return isNaN(n) ? v : n;
    });
  }
  /**
   *@param {string} v1
   *@param {string} v2
   *@param {Boolean} [greatAndEqual]
   */
  static compare(v1, v2, greatAndEqual = true) {
    return new Version(v1).compare(v2, greatAndEqual);
  }
}
